(() => {
  if (window.bbaStockOrderBound) return;
  const container = document.getElementById('ProductGridContainer');
  if (!container || location.pathname === '/collections/sale' || location.pathname === '/collections/sale/' || document.querySelector('[data-bba-makeup-filters], [data-bba-skin-filters], [data-shopall-filters], [data-perfume-filters]')) return;
  window.bbaStockOrderBound = true;
  let revision = 0, controller;
  const observer = new MutationObserver(() => refresh());
  const observe = () => observer.observe(container, { childList: true });
  async function refresh() {
    const grid = container.querySelector('#product-grid');
    if (!grid || !grid.children.length) return;
    const ownRevision = ++revision;
    controller?.abort(); controller = new AbortController();
    const params = new URLSearchParams(location.search);
    const url = new URL(location.pathname, location.origin);
    for (const [key, value] of params) if (key !== 'page' && key !== 'section_id') url.searchParams.append(key, value);
    url.searchParams.set('section_id', 'bba-stock-source');
    container.setAttribute('aria-busy', 'true');
    try {
      const records = [], ids = new Set(), pages = new Set();
      let next = url, config;
      while (next) {
        if (next.origin !== location.origin || pages.has(next.href)) throw Error('Invalid collection page');
        pages.add(next.href);
        const response = await fetch(next, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = JSON.parse(doc.querySelector('[data-stock-page]').textContent);
        config = page;
        for (const template of doc.querySelectorAll('[data-stock-record]')) {
          if (ids.has(template.dataset.id)) throw Error('Duplicate product');
          ids.add(template.dataset.id);
          records.push({ available: template.dataset.available === 'true', card: template.content.querySelector('li') });
        }
        next = page.next ? new URL(page.next, location.origin) : null;
        if (next) for (const [key, value] of url.searchParams) if (key !== 'page' && !next.searchParams.has(key)) next.searchParams.append(key, value);
      }
      if (ownRevision !== revision || !grid.isConnected) return;
      if (records.length !== config.total || records.some(item => !item.card)) throw Error('Incomplete collection');
      const ordered = records.filter(item => item.available).concat(records.filter(item => !item.available));
      let shown = config.all ? ordered.length : Math.min(ordered.length, Math.max(12, (Number(params.get('page')) || 1) * 12));
      observer.disconnect();
      container.querySelectorAll('bba-catalog-more, [data-bba-infinite-scroll], [data-stock-more], .pagination-wrapper').forEach(node => node.remove());
      const more = document.createElement('div'); more.dataset.stockMore = ''; more.className = 'bba-catalog__more';
      const button = document.createElement('button'); button.type = 'button'; button.className = 'bba-catalog__button'; button.textContent = config.label;
      const status = document.createElement('p'); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      more.append(button, status); grid.after(more);
      function render() {
        grid.replaceChildren(...ordered.slice(0, shown).map(item => document.importNode(item.card, true)));
        button.hidden = shown >= ordered.length;
        status.textContent = config.progress.replace('__SHOWN__', shown).replace('__TOTAL__', ordered.length);
        document.dispatchEvent(new CustomEvent('bba:collection-products-loaded', { detail: { count: shown } }));
      }
      button.addEventListener('click', () => { shown = Math.min(shown + 12, ordered.length); render(); });
      render(); observe();
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('Stock ordering unavailable; original collection retained.', error);
    } finally {
      if (ownRevision === revision) container.removeAttribute('aria-busy');
    }
  }
  observe(); refresh();
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
})();
